module.exports = __webpack_public_path__ + "static/media/aws.feffef25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aws.svg
// module id = 1312
// module chunks = 49